export default class PlateTypeManagementColumnModel {
	static PlateTypeManagementColumn = [
	  {
		  title: 'Pallet type',
		  align: 'left',
		  field: 'plateTypeName'
	  }
	]
}
